import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  breadcrumbContainer: {
    marginTop: 75,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    marginBottom:-90,
  },

   customLink: {
    textDecoration: 'none',
    color: '#00DD9E',
    fontWeight: 'bold',
        '&:hover': {
      color: theme.palette.text.secondary,
      textDecoration: 'none',
    },
  },
  fontLink: {
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '26px',
  },
  subtitle: {
    fontWeight: '400',
    fontFamily: 'Montserrat',
    color: theme.palette.text.secondary,
    fontStyle: 'normal',
    fontSize: '18px',
    lineHeight: '32px',
    textAlign: 'center',
    whiteSpace: 'pre-wrap',
  },
  heading: {
    fontWeight: '800',
    fontFamily: 'Montserrat',
    color: '#06E89F',
    fontStyle: 'normal',
    fontSize: '56px',
    lineHeight: '64px',
    textAlign: 'center',
    '@media only screen and (max-width: 320px)': {
      fontSize: '2em',
    },
  },

  container: {
    maxWidth: 900,
  },
  containerFrecuentQuestion:{
marginTop:80
  },
  answers: {
    fontWeight: '400',
    fontFamily: 'Montserrat',
    color: theme.palette.text.secondary,
    fontStyle: 'normal',
    fontSize: '14px',
    lineHeight: '24px',
  },
  link: {
    textDecoration: 'none',
    color: '#06E89F',
  },
}));
export default useStyles;
